import { Option } from '../types/utility';

export const AU_STATE_OPTIONS: Option<string>[] = [
  {
    label: 'Australian Capital Territory',
    value: 'ACT',
  },
  {
    label: 'New South Wales',
    value: 'NSW',
  },
  {
    label: 'Northern Territory',
    value: 'NT',
  },
  {
    label: 'Queensland',
    value: 'QLD',
  },
  {
    label: 'South Australia',
    value: 'SA',
  },
  {
    label: 'Tasmania',
    value: 'TAS',
  },
  {
    label: 'Victoria',
    value: 'VIC',
  },
  {
    label: 'Western Australia',
    value: 'WA',
  },
];

export const twoFactorOptions: Option<string>[] = [
  {
    label: 'App',
    value: 'app',
  },
  {
    label: 'No 2FA',
    value: 'is_null',
  },
  {
    label: 'Mail',
    value: 'mail',
  },
  {
    label: '2FA enabled',
    value: 'not_null',
  },
];
